import React from 'react';

const TablePagination = ({ page, totalPages, limit, setPage, setLimit }) => {
    return (
        <div className="pagination">
            <button onClick={() => setPage(page - 1)} disabled={page === 1}>
                Previous
            </button>
            <span>Page {page} of {totalPages}</span>
            <button onClick={() => setPage(page + 1)} disabled={page === totalPages}>
                Next
            </button>
            <select onChange={(e) => setLimit(Number(e.target.value))} value={limit}>
                <option value={10}>10</option>
                <option value={50}>50</option>
                <option value={100}>100</option>
                <option value={200}>200</option>
                <option value={500}>500</option>
                <option value={1000}>1000</option>
            </select>
        </div>
    );
};

export default TablePagination;
